module.exports = __webpack_public_path__ + "img/media_18.b5f4d6ee.jpg";